import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var $: any;
declare var bootstrap: any;

@Injectable()
export class Helpers {

  setDataTableSearchDelay() {
    var searchDelay = null;

    setTimeout(function () {
      $('.dataTables_filter input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function (e) {
          var search = $('div.dataTables_filter input').val();
          clearTimeout(searchDelay);

          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }

  getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => {

      if (object[key] != null) {

        if (object[key].constructor.name == "Array") {
          let i = 0;
          object[key].forEach(function (arr) {
            formData.append(`${key}[${i}]`, arr);
            i++;
          })
        }

        else if (object[key] instanceof Object && object[key].constructor.name != "File") {
          for (const subKey in object[key]) {
            if (object[key].hasOwnProperty(subKey)) {
              formData.append(`${key}.${subKey}`, object[key][subKey]);
            }
          }
        }
        else {
          formData.append(key, object[key]);
        }
      }
    });
    return formData;
  }


  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  /**
   * Devuelve una fecha del tipo DateTime en 2 partes y con iconos de fecha y hora
   * @param {string} stringDate : Fecha hora en formato texto
   * @return {string} newStringDate
   */
  formatDateTimeWithIcons(stringDate: string) {
    stringDate = stringDate.replace(/<[^>]*>/g, '').trim();
    let newStringDate = '';
    let tempStringArr = stringDate.split(' ');
    let tempString = '<span class="text-nowrap me-2"><i class="fa fa-calendar"></i> ';
    tempString += tempStringArr[0] + '</span>';
    if (tempStringArr.length > 1) {
      tempString += '<span class="text-nowrap"><i class="fa fa-clock-o"></i> ';
      tempString += tempStringArr[1] + '</span>';
    }
    newStringDate = tempString;
    return newStringDate;
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  /**
   * Activa los tooltips de Bootstrap
   * Usado tras un cambio en el DOM
   * Sobre todo en los datatables
   */
  enableBsTooltips() {
    $('.tooltip').remove();
    var tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipElements.forEach(function (tooltipElement) {
      $('.tooltip').remove();
      var tooltip = bootstrap.Tooltip.getOrCreateInstance(tooltipElement);
    });
    $('[data-bs-toggle="tooltip"]').on("mousedown", function () {
      $('.tooltip').remove();
    });
  }

  clearBsTooltips() {
    $('.tooltip').remove();
  }

  enableBsPopovers() {
    $('.popover').remove();
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    });
  }

  clearBsPopovers() {
    $('.popover').remove();
  }

  isApiUrl(req: any) {
    if (req.url.startsWith(environment.urlAPI)) {
      return true;
    }
    return false;
  }

  isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }

  /**
   * Comprueba si estamos en un entorno de desarrollo
   * Usa como referencia la URL de la API
   */
  isInDevEnvironment() {
    // It's a development remote url.
    if (environment.urlAPI.startsWith('https://dev-api')) {
      return true;
    }

    // It's a development local url.
    if (environment.urlAPI.startsWith('https://localhost')) {
      return true;
    }

    return false;
  }

  isInUatEnvironment() {
    // It's a development remote url.
    if (environment.urlAPI.startsWith('https://uat-api')) {
      return true;
    }

    // It's a development local url.
    if (environment.urlAPI.startsWith('https://localhost')) {
      return true;
    }

    return false;
  }

  base64ToBlob(base64: string, mimeType: string): Blob {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }

  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // offset es el número de píxeles que se debe tener en cuenta para que el elemento esté en el viewport
  // selector es el selector css del elemento que se debe comprobar
  elementIsInViewport(offset: number = 480, selector: string): boolean {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) return false; // seguridad por si no existe

    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // Geometría: el elemento toca el viewport (con offset)
    const intersectsViewport =
      rect.bottom > -offset && rect.top < windowHeight + offset;

    // Visibilidad: el elemento y sus padres no están ocultos por CSS
    const isVisible =
      !!(element.offsetParent !== null) && // descarta display:none
      window.getComputedStyle(element).visibility !== 'hidden' &&
      window.getComputedStyle(element).opacity !== '0';

    return intersectsViewport && isVisible;
  }
}


